module.exports = __webpack_public_path__ + "img/icon-flexible-doctor-schedule.88a3059.svg";